import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react';
import i18next from 'i18next';
import ItemsList from './ItemsList';
import { getActiveUpsell } from '../../../selectors';
import { endUpsell } from '../../../actions';

const UpsellsModal = (props) => {
    const dispatch = useDispatch();
    const upsell = useSelector(state => getActiveUpsell(state));

    const open = !!upsell;
    const { title, items, trigger } = upsell || {};

    function handleClose() {
        dispatch(endUpsell(trigger));
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Modal.Header>
                {title || i18next.t('order.upsellHeader')}
            </Modal.Header>
            <Modal.Content scrolling>
                <ItemsList items={items} onSelect={handleClose} />
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={handleClose}>
                    {i18next.t('order.upsellReject')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default UpsellsModal;
